export default "__VITE_ASSET__Brn$PLl3__"